<div class="flex flex-column">
	<form #formPaymentForm="ngForm">
		<div class="my-2">
			<span class="p-float-label">
				<input
					required
					[formControl]="controlPurchaserFirstName"
					name="firstname"
					type="text"
					id="firstname"
					pInputText
					[(ngModel)]="transaction.purchaserFirstName"
					class="w-100"
				/>
				<label for="inputtext">Your First Name</label>
			</span>
			<div *ngIf="(controlPurchaserFirstName.dirty || controlPurchaserFirstName.touched) && controlPurchaserFirstName.hasError('required')">
				<span class="text-danger">Required</span>
			</div>
		</div>
		<div class="my-4">
			<span class="p-float-label">
				<input
					required
					[formControl]="controlPurchaserLastName"
					name="lastname"
					type="text"
					id="lastname"
					pInputText
					[(ngModel)]="transaction.purchaserLastName"
					class="w-100"
				/>
				<label for="inputtext">Your Last Name</label>
			</span>
			<div *ngIf="(controlPurchaserLastName.dirty || controlPurchaserLastName.touched) && controlPurchaserLastName.hasError('required')">
				<span class="text-danger">Required</span>
			</div>
		</div>
		<div class="my-4">
			<span class="p-float-label">
				<input
					[formControl]="controlPurchaserEmail"
					#purchaserEmail
					required
					name="email"
					type="email"
					pInputText
					[(ngModel)]="transaction.purchaserEmail"
					pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
					class="w-100"
				/>
				<label for="inputtext">Your Email Address</label>
			</span>
			<div *ngIf="(controlPurchaserEmail.dirty || controlPurchaserEmail.touched) && controlPurchaserEmail.hasError">
				<div *ngIf="controlPurchaserEmail.hasError('email')">
					<span class="text-danger">Invalid email address</span>
				</div>
				<div *ngIf="controlPurchaserEmail.hasError('required')">
					<span class="text-danger">Required</span>
				</div>
			</div>
		</div>
		<div class="my-4 p-fluid">
			<p-selectButton
				name="forSelect"
				[options]="forOptions"
				[(ngModel)]="for"
				optionLabel="label"
				optionValue="value"
				syleClass="w-100"
				[style]="{ width: '100%' }"
			></p-selectButton>
		</div>
		<div *ngIf="for === 'friend'">
			<div class="my-4">
				<span class="p-float-label">
					<input required name="recipientName" type="text" id="recipientName" pInputText [(ngModel)]="transaction.recipientName" class="w-100" />
					<label for="inputtext">Recipient's Name</label>
				</span>
			</div>
			<div class="my-4">
				<span class="p-float-label">
					<input
						required
						[formControl]="controlRecipientEmail"
						name="recipientEmail"
						type="email"
						id="recipientEmail"
						pInputText
						[(ngModel)]="transaction.recipientEmail"
						class="w-100"
					/>
					<label for="inputtext">Recipient's Email</label>
				</span>
				<div *ngIf="controlRecipientEmail.errors && controlRecipientEmail.hasError('email')">
					<span class="text-danger">Invalid email address</span>
				</div>
			</div>
			<div class="my-4">
				<textarea
					name="note"
					id="note"
					pInputTextarea
					[(ngModel)]="transaction.note"
					placeholder="A little note to your friend ♥"
					class="w-100"
				></textarea>
			</div>
		</div>
		<div class="my-4 p-fluid mb-3 text-center">
			<p-selectButton
				required
				name="sendSelect"
				id="sendSelect"
				[options]="sendOptions"
				[(ngModel)]="transaction.delaySend"
				optionLabel="label"
				optionValue="value"
			></p-selectButton>
		</div>
		<div *ngIf="transaction.delaySend" class="my-4">
			<p-calendar
				placeholder="When would you like to send..."
				required
				name="sendDateTime"
				id="sendDateTime"
				[(ngModel)]="sendDateTime"
				[showTime]="true"
				hourFormat="12"
				inputId="sendDateTime"
				(onSelect)="onChange($event)"
				(onInput)="onChange($event)"
				styleClass="w-100"
			></p-calendar>
		</div>
		<p-button
			[disabled]="
				formPaymentForm.invalid ||
				controlPurchaserLastName.invalid ||
				controlPurchaserFirstName.invalid ||
				(for === 'friend' &&
					(!controlRecipientEmail.value || (controlRecipientEmail.invalid && controlRecipientEmail.hasError)) &&
					!controlRecipientName.value)
			"
			pRipple
			styleClass="p-button-success p-button-raised my-4 w-100 text-center"
			label="Checkout"
			(click)="submitTransaction()"
		></p-button>
	</form>
</div>
